//
//
//
//
//
//
//
export default {
  props: {
    linkType: {
      type: String
    },
    url: {
      type: String
    },
    page: {
      type: Object
    },
    isButton: {
      type: Boolean
    }
  }
};